import { render, staticRenderFns } from "./DetailVendor.vue?vue&type=template&id=036c7de0"
import script from "./DetailVendor.vue?vue&type=script&lang=js"
export * from "./DetailVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports